/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

export const SubscriptionInfo = ({ info }) => {
  const pluses = info.pluses.split('\n');
  const workSteps = info.work.split('\n');

  if (pluses.length === 0 && workSteps.length === 0 && info.description.length === 0) {
    return <></>;
  }

  return (
    <Content>
      {info.description.length > 0 && (
        <>
          <Section>Подробнее о подписки:</Section>
          <p>{info.description}</p>
        </>
      )}

      {pluses.length > 0 && (
        <>
          <Section>Преимущества подписки:</Section>
          <ul>
            {info.pluses.split('\n').map((text) => {
              const [title, content] = text.split(': ');

              return (
                <li key={title}>
                  <strong>{title}</strong>
                  {' '}
                  {content}
                </li>
              );
            })}
          </ul>
        </>
      )}

      {workSteps.length > 0 && (
        <>
          <Section>Как это работает:</Section>
          <ul>
            {workSteps.map((text) => {
              const [title, content] = text.split(': ');

              return (
                <li key={title}>
                  <strong>{title}</strong>
                  {' '}
                  {content}
                </li>
              );
            })}
          </ul>
        </>
      )}
    </Content>
  );
};

const Content = styled.div`
  width: 100%;
  margin-top: 24px;
`;

const Section = styled.h6`
`;
